/* @flow */

export const validation = {
  maxTitleChar: 90,
  maxParagraph: 400
}
